import React from 'react';

import useSearchbar from '@contexts/searchbar';
import { ResponsiveDrawerInterface } from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import SelectedComponent from '@shared/searchBar/datePicker/selectedComponent';
import EmptyComp from '@shared/searchBar/datePicker/emptyComp';
import { formatMomentDate, formatShortLocalDate } from '@utils/dateUtil';

import { ResponsiveSearchDrawerItemContent } from './styled';

const FlightResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  onClick = () => false,
  startDate,
  endDate,
  onFocusChange,
}) => {
  const {
    state: { flight: state },
  } = useSearchbar();

  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
    >
      <SelectedComponent
        value={formatShortLocalDate(formatMomentDate(startDate))}
        label='Gidiş'
        isOneWay={state?.isOneWay}
        rightBorder
        onClick={() => onFocusChange?.('startDate')}
      />

      {state.isOneWay ? null : !endDate ? (
        <EmptyComp label='Dönüş' onClick={() => onFocusChange?.('endDate')} />
      ) : (
        <SelectedComponent
          value={formatShortLocalDate(formatMomentDate(endDate))}
          label='Dönüş'
          onClick={() => onFocusChange?.('endDate')}
        />
      )}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default FlightResponsiveSearchDrawerItem;
